import { flex, flexColumn } from 'hfty-styles/src/mixins'

const CONTENT_MAX_WIDTH = '1600px'

export const styles = {
  orderTestsLayout: {
    ...flex('center', 'flex-start'),
    width: '100%',
  },
  layoutContent: {
    ...flexColumn(),
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
    padding: '50px',
  },

  layoutHeader: {
    width: '100%',
  },

  layoutTable: {
    width: '100%',
  },

  layoutFooter: {
    width: '100%',
  },
}
